import ChevronDown16 from '@carbon/icons-react/es/chevron--down/16';
import { List, Row, Col } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { snakeCase, uniqBy } from 'lodash';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { LinkButton } from 'components/atoms/button';
import { Checkbox } from 'components/atoms/checkbox';
import { ReminderPicker } from '../../common';
import { Collapse, ListItem, Panel } from './notification-collapse.styles';
import { NotificationCollapseTypes } from './notification-collapse.types';

export const NotificationCollapse = ({
  type,
  notifications = [],
  onNotificationChange,
  timeConfigurable,
}: NotificationCollapseTypes) => {
  const handleChecked = (e: CheckboxChangeEvent) => {
    const notification = notifications.find(
      (n) => n.eventType === e.target.value,
    );

    onNotificationChange([
      {
        ...(notification ?? {}),
        eventType: e.target.value,
        channels: {
          SLACK: e.target.checked,
        },
      },
    ]);
  };

  const uniqueNotifications = useMemo(
    () => uniqBy(notifications, 'eventType'),
    [notifications],
  );

  return (
    <Collapse bordered={false} expandIcon={() => null}>
      <Panel
        header={
          notifications.length > 0 ? (
            <LinkButton icon={<ChevronDown16 />} iconPlacement="right">
              <FormattedMessage id="settings.integrations.slack.notifications.expand.text" />
            </LinkButton>
          ) : null
        }
        key={type}
      >
        <List
          dataSource={uniqueNotifications}
          renderItem={(notification) => (
            <ListItem>
              <Row>
                <Col flex="450px">
                  <FormattedMessage
                    id={`settings.integrations.slack.notifications.${snakeCase(
                      notification.eventType,
                    )}`}
                  />
                  {timeConfigurable?.includes(notification.eventType) ? (
                    <ReminderPicker
                      notification={notification}
                      onNotificationChange={onNotificationChange}
                    />
                  ) : null}
                </Col>
                <Col>
                  <Checkbox
                    value={notification.eventType}
                    checked={notification.channels.SLACK}
                    onChange={handleChecked}
                  />
                </Col>
              </Row>
            </ListItem>
          )}
        />
      </Panel>
    </Collapse>
  );
};
